/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsUpdate } from "../../funcs/accountsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PutApiWorkspaceServiceV1AccountsRequestBody$inboundSchema,
};

export const tool$accountsUpdate: ToolDefinition<typeof args> = {
  name: "accounts_update",
  description: `Update account details`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
